import { ForwardedRef, forwardRef } from 'react';
import { RouteTabLink, RouteTabLinkProps } from '../tabs/RouteTabLink';

export const SubTabsButton = forwardRef(
  (props: RouteTabLinkProps, ref: ForwardedRef<HTMLAnchorElement>) => {
    return <RouteTabLink ref={ref} {...props} />;
  }
);
SubTabsButton.displayName = 'SubTabsButton';
